import React, { Dispatch, SetStateAction, useState } from 'react';
import { IDiscoveryPreSetData } from '../dto/IDiscoveryFilter';
import { useTranslation } from 'react-i18next';
import { CustomAutocomplete } from '../../../../../shared/components/Autocomplete';

interface IDiscoveryPresetFilterDropdownProps {
  presetOptions: IDiscoveryPreSetData[];
  count: number;
  presetFilterAction: (filterId: number) => void;
  clearPresetFilter: () => void;
  setFilterParams: Dispatch<SetStateAction<{ perPage: number; page: number }>>;
  filterParams: { perPage: number; page: number };
  setSelectedPresetOption: Dispatch<SetStateAction<number | null>>;
  selectedPresetOption: number | null;
  isDiscoveryLimited?: boolean;
}

function DiscoveryPresetFilterDropdown({
                                         presetOptions,
                                         count,
                                         presetFilterAction,
                                         clearPresetFilter,
                                         setFilterParams,
                                         filterParams,
                                         setSelectedPresetOption,
                                         selectedPresetOption,
                                         isDiscoveryLimited,
                                       }: IDiscoveryPresetFilterDropdownProps) {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  const selectedValue = presetOptions?.find(o => o.id === selectedPresetOption) ?? null;

  return (
    <CustomAutocomplete
      isWithImage={false}
      key={selectedPresetOption ?? 'none'}
      isDisabled={isDiscoveryLimited}
      dataArray={presetOptions ?? []}
      defaultArray={selectedValue}
      inputLabel="title"
      inputLabelTranslation={t('brand.campaign.discovery.filter_preset', { count: Number(count) || 0 })}
      changeEventKey="title"
      queryFilterKey="presetId"
      disableClearable={false}
      classes="w-auto"
      openDropdown={open}
      handleOpenDropdown={() => {
        setFilterParams(prev => ({ ...prev, perPage: count || 100 }));
        setOpen(true);
      }}
      handleCloseDropdown={() => setOpen(false)}
      handleChangeParams={(key, value) => {
        if (!value) {
          clearPresetFilter();
          setSelectedPresetOption(null);
          return;
        }
        const selected = presetOptions?.find(o => o.id === Number(value));
        if (selected) {
          setSelectedPresetOption(selected.id);
          presetFilterAction(selected.id);
        }
      }}
    />
  );
}

export default React.memo(DiscoveryPresetFilterDropdown);
